export default __webpack_public_path__ + "static/media/condominium.d37d07fd.jpg";